'use client';

import {NavigationMenuLink} from '@/components/ui/navigation-menu';
import {cn} from '@/lib/utils';
import Logo from '@/assets/images/Logo.svg';
import Link from 'next/link';
import * as React from 'react';
import {Button} from '@/components/ui/button';

export default function Header({
  withSections = false,
  withSignIn = true,
}: {
  withSections?: boolean;
  withSignIn?: boolean;
}) {
  return (
    <header className="w-full sticky top-0 flex flex-row bg-white py-4 px-8 z-10 gap-4">
      <div className="flex-1 flex flex-row items-center">
        <Link href="/">
          <Logo width={182} height={48} />
        </Link>
      </div>
      {withSections && (
        <div className="flex-1 hidden xl:flex flex-row gap-2 items-centers justify-center">
          <Link href="#highlights" scroll={true}>
            <Button
              variant="link"
              className="text-secondary min-w-0 font-semibold"
            >
              Funzionalità
            </Button>
          </Link>
          <Link href="#pricing" scroll={true}>
            <Button
              variant="link"
              className="text-secondary min-w-0 font-semibold"
            >
              Prezzi
            </Button>
          </Link>
          <Link href="#contact-us" scroll={true}>
            <Button
              variant="link"
              className="text-secondary min-w-0 font-semibold"
            >
              Contattaci
            </Button>
          </Link>
          <Link href="#sources" scroll={true}>
            <Button
              variant="link"
              className="text-secondary min-w-0 font-semibold"
            >
              Fonti
            </Button>
          </Link>
        </div>
      )}
      {withSignIn && (
        <div className="flex-1 flex flex-row gap-4 items-center justify-end">
          <Link href={`${process.env.NEXT_PUBLIC_NAI_APP_URL}`}>
            <Button variant="secondary" className="min-w-0 md:min-w-48">
              Accedi
            </Button>
          </Link>
          <Link
            href={`${process.env.NEXT_PUBLIC_NAI_APP_URL}/sign-up`}
            className="hidden md:flex"
          >
            <Button>Attiva la Prova Gratuita</Button>
          </Link>
        </div>
      )}
    </header>
  );
}

const ListItem = React.forwardRef<
  React.ElementRef<'a'>,
  React.ComponentPropsWithoutRef<'a'>
>(({className, title, children, ...props}, ref) => {
  return (
    <li>
      <NavigationMenuLink asChild>
        <a
          ref={ref}
          className={cn(
            'block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground',
            className,
          )}
          {...props}
        >
          <div className="text-sm font-medium leading-none">{title}</div>
          <p className="line-clamp-2 text-sm leading-snug text-muted-foreground">
            {children}
          </p>
        </a>
      </NavigationMenuLink>
    </li>
  );
});
ListItem.displayName = 'ListItem';
